import { Translator } from '../i18n';

export const Data = [
    {
        id: 1,
        title: <Translator path='Certificates.title_one'/>,
        time: "6",
        time_text: <Translator path='Certificates.time_one'/>,
    },

    {
        id: 2,
        title: <Translator path='Certificates.title_two'/>,
        time: "8",
        time_text: <Translator path='Certificates.time_one'/>,
    },

    {
        id: 3,
        title: <Translator path='Certificates.title_three'/>,
        time: "9",
        time_text: <Translator path='Certificates.time_one'/>,
    },

    {
        id: 4,
        title: "DIO Campus Expert._ Workshop",
        time: "10",
        time_text: <Translator path='Certificates.time_one'/>,
    },

    {
        id: 5,
        title: <Translator path='Certificates.title_five'/>,
        time: "5",
        time_text: <Translator path='Certificates.time_one'/>,
    },

    {
        id: 6,
        title: <Translator path='Certificates.title_six'/>,
        time: "8",
        time_text: <Translator path='Certificates.time_one'/>,
    },

    {
        id: 7,
        title: <Translator path='Certificates.title_seven'/>,
        time: "10",
        time_text: <Translator path='Certificates.time_one'/>,
    },

    {
        id: 8,
        title: <Translator path='Certificates.title_eight'/>,
        time: "40",
        time_text: <Translator path='Certificates.time_one'/>,
    },

    {
        id: 9,
        title: <Translator path='Certificates.title_nine'/>,
        time: "120",
        time_text: <Translator path='Certificates.time_one'/>,
    },

    {
        id: 10,
        title: <Translator path='Certificates.title_ten'/>,
        time: "35",
        time_text: <Translator path='Certificates.time_one'/>,
    },

    {
        id: 11,
        title: <Translator path='Certificates.title_eleven'/>,
        time: "20",
        time_text: <Translator path='Certificates.time_one'/>,
    },

    {
        id: 12,
        title: "Inter Frontend Developer",
        time: "99",
        time_text: <Translator path='Certificates.time_one'/>,
    },

    {
        id: 13,
        title: <Translator path='Certificates.title_thirteen'/>,
        time: "6",
        time_text: <Translator path='Certificates.time_one'/>,
    },

    {
        id: 14,
        title: <Translator path='Certificates.title_fourteen'/>,
        time: "6",
        time_text: <Translator path='Certificates.time_one'/>,
    },

    {
        id: 15,
        title: <Translator path='Certificates.title_fiveteen'/>,
        time: "5",
        time_text: <Translator path='Certificates.time_one'/>,
    },

    {
        id: 16,
        title: "Java Front/Back",
        time: "33",
        time_text: <Translator path='Certificates.time_one'/>,
    },

    {
        id: 17,
        title: <Translator path='Certificates.title_seventeen'/>,
        time: "5",
        time_text: <Translator path='Certificates.time_one'/>,
    },

    {
        id: 18,
        title: <Translator path='Certificates.title_eighteen'/>,
        time: "5",
        time_text: <Translator path='Certificates.time_one'/>,
    },

    {
        id: 19,
        title: "Órbi Web Games Developer",
        time: "63",
        time_text: <Translator path='Certificates.time_one'/>,
    },

    {
        id: 20,
        title: <Translator path='Certificates.title_twenty'/>,
        time: "16",
        time_text: <Translator path='Certificates.time_one'/>,
    },

    {
        id: 21,
        title: "Santander Bootcamp | FullStack Developer",
        time: "125",
        time_text: <Translator path='Certificates.time_one'/>,
    },

    {
        id: 22,
        title: "Take Blip Web Developer",
        time: "78",
        time_text: <Translator path='Certificates.time_one'/>,
    },

    {
        id: 23,
        title: <Translator path='Certificates.title_twentythree'/>,
        time: "8",
        time_text: <Translator path='Certificates.time_one'/>,
    },
   
]